import { ExternalLink, Award, BadgeCheck, FileCheck2, ShieldCheck, MapPin } from "lucide-react";
import { siteConfig } from "../data/siteConfig";
import { founderDetails } from "../data/homePageContent";

export function AboutFounderSection() {
  return (
    <section className="site-shell section about-founder" id="about">
      <div className="section-heading reveal">
        <p className="kicker">About the founder</p>
        <h2>A preparer who handles your return personally.</h2>
      </div>
      <div className="about-founder__grid reveal reveal--delay">
        <div className="about-founder__profile">
          <div className="about-founder__image-wrap">
            <img
              src="/founder-gaurab-subedi.png"
              alt="Gaurab Subedi, Founder of Subedi Tax Pro"
              className="about-founder__image"
              loading="lazy"
            />
          </div>
          <div className="about-founder__badge">
            <ShieldCheck size={18} className="text-ember" aria-hidden="true" />
            <span>CTEC Registered Preparer</span>
          </div>
        </div>
        <div className="about-founder__content">
          <h3 className="about-founder__name">{founderDetails.name}</h3>
          <p className="about-founder__title">{founderDetails.subtitle}</p>
          <p className="about-founder__bio">{founderDetails.bio}</p>
          <p className="about-founder__mission">
            &ldquo;Every tax return represents someone&rsquo;s hard-earned livelihood. My clients get a
            filing process that stays simple on their end, and a preparer who checks every line before
            anything is sent to the IRS.&rdquo;
          </p>
          <div className="credentials-card">
            <h4 className="credentials-card__title">Licensing &amp; Registrations</h4>
            <div className="credentials-list">
              <div className="credential-item">
                <BadgeCheck size={18} className="credential-item__icon" aria-hidden="true" />
                <div>
                  <strong>CTEC Registered Tax Preparer (CRTP)</strong>
                  <span>
                    {siteConfig.ctecNumber
                      ? `California Tax Education Council \u00b7 CRTP ${siteConfig.ctecNumber}`
                      : "California Tax Education Council"}
                  </span>
                </div>
              </div>
              <div className="credential-item">
                <ShieldCheck size={18} className="credential-item__icon" aria-hidden="true" />
                <div>
                  <strong>Authorized IRS e-file Provider (ERO)</strong>
                  <span>Returns filed electronically with the IRS</span>
                </div>
              </div>
              <div className="credential-item">
                <FileCheck2 size={18} className="credential-item__icon" aria-hidden="true" />
                <div>
                  <strong>IRS Preparer Tax Identification Number (PTIN)</strong>
                  <span>Active</span>
                </div>
              </div>
              <div className="credential-item">
                <Award size={18} className="credential-item__icon" aria-hidden="true" />
                <div>
                  <strong>Sacramento County Business License</strong>
                  <span>{siteConfig.countyLicense} (Tax Preparation Services)</span>
                </div>
              </div>
              <div className="credential-item">
                <MapPin size={18} className="credential-item__icon" aria-hidden="true" />
                <div>
                  <strong>Jurisdiction &amp; Office</strong>
                  <span>{siteConfig.location} (Serving all California residents remotely)</span>
                </div>
              </div>
            </div>
            <div className="credentials-card__footer">
              <a
                href={siteConfig.linkedinUrl}
                target="_blank"
                rel="noreferrer noopener"
                className="linkedin-link"
              >
                <span>Connect on LinkedIn</span>
                <ExternalLink size={15} aria-hidden="true" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
